import { z } from "zod";

export const generateTermSchema = z.object({
  cpf: z
    .string({
      required_error: "CPF é obrigatório",
    })
    .nonempty("O CPF é obrigatório")
    .transform((val) => val.replace(/\D/g, "")) 
    .refine((val) => val.length === 11, "CPF deve ter 11 dígitos")
    .refine(
      (val) => /^\d{11}$/.test(val),
      "CPF deve conter exatamente 11 dígitos numéricos"
    ),
  storeCode: z
    .string({
      required_error: "Código da loja é obrigatório",
    })
    .min(1, "Código da loja é obrigatório"),
  reason: z.enum(
    [
      "FERIAS",
      "TROCA_GERENTE",
      "ATESTADO",
      "DESLIGAMENTO",
      "LICENCA_MATERNIDADE",
      "PEDIDO_DEMISSAO",
    ],
    {
      required_error: "Motivo é obrigatório",
    }
  ),
  treasuryAuditDate: z
    .date({
      required_error: "Data de Solicitação do Saldo é obrigatória",
    })
    .refine(
      (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dateToCheck = new Date(date);
        dateToCheck.setHours(0, 0, 0, 0);
        return dateToCheck <= today;
      },
      { message: "A data não pode ser futura" }
    ),
  hasBalanceDiscrepancy: z.boolean(),
  cashBalance: z
    .string({
      required_error: "Saldo conferido Tesouraria é obrigatório",
    })
    .transform((val) => val.replace(/\D/g, "")),
  justification: z
    .string()
    .max(200, "A justificativa deve ter no máximo 200 caracteres")
    .optional()
    .transform((val) => val || undefined),
  file: z
    .instanceof(File, { message: "Arquivo é obrigatório" })
    .refine((file) => file.type === "application/pdf", {
      message: "Arquivo deve ser PDF",
    }),
});
